import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaDocumentosCheques', NominasNominaDocumentosCheques)

function NominasNominaDocumentosCheques($http) {
  this.get = get

  function get(id_proyecto, id_nomina, id_cuenta_retiro, data, imprimir_reverso, redondear_importes) {
    return $http.post('/api/nominas/nomina/documentos/cheques', data, {
      params: {
        id_proyecto: id_proyecto,
        id_nomina: id_nomina,
        id_cuenta_retiro: id_cuenta_retiro,
        imprimir_reverso: imprimir_reverso ? 1 : undefined,
        redondear_importes: redondear_importes ? 1 : undefined,
      },
      headers: {
        'X-HTTP-Method-Override': 'GET',
      },
      responseType: 'blob',
      clearCache: 'nominas',
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos/Cheques.js